import React from "react";
import styled, { keyframes } from "styled-components";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import { VpnKey, Business, Description, Link, AccountCircle, Lock, Fingerprint } from "@material-ui/icons";

function TabConcur({ values, touched, errors, handleChange, formik }) {
  return (
    <ModernFormContainer>
      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#667eea">
              <Business />
            </SectionIcon>
            <SectionTitle>Informações Gerais</SectionTitle>
          </SectionHeader>
          <FormGrid columns={2}>
            <StyledFieldContainer>
              <FieldLabel>
                <Fingerprint style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
                ID
              </FieldLabel>
              <TextField
                fullWidth
                InputLabelProps={{ shrink: true }}
                disabled
                id="id"
                name="id"
                placeholder="ID"
                value={values.id}
                onChange={handleChange}
                error={touched.id && Boolean(errors.id)}
                helperText={touched.id && errors.id}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
            <FormLabel>
              <Checkbox
                id="ativo"
                name="ativo"
                checked={values.ativo}
                onChange={handleChange}
                color="primary"
              />
              <StatusText active={values.ativo}>
                {values.ativo ? "✓ Ativo" : "✗ Inativo"}
              </StatusText>
            </FormLabel>
          </FormGrid>
        </SectionCard>
      )}

      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#3498db">
            <Description />
          </SectionIcon>
          <SectionTitle>Dados da Credencial</SectionTitle>
        </SectionHeader>
        <FormGrid columns={1}>
          <StyledFieldContainer>
            <FieldLabel>
              <Business style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
              Nome da Credencial
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="name"
              name="name"
              placeholder="Nome da credencial"
              value={values.name}
              onChange={handleChange}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>
          <StyledFieldContainer>
            <FieldLabel>
              <Description style={{ fontSize: '18px', marginRight: '8px', color: '#f39c12' }} />
              Descrição
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="description"
              name="description"
              placeholder="Descrição da credencial"
              value={values.description}
              onChange={handleChange}
              error={touched.description && Boolean(errors.description)}
              helperText={touched.description && errors.description}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>
          <StyledFieldContainer>
            <FieldLabel>
              <Link style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
              URL
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="url"
              name="url"
              placeholder="https://..."
              value={values.url}
              onChange={handleChange}
              error={touched.url && Boolean(errors.url)}
              helperText={touched.url && errors.url}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>
        </FormGrid>
      </SectionCard>

      <SectionCard>
        <SectionHeader>
          <SectionIcon color="#9b59b6">
            <VpnKey />
          </SectionIcon>
          <SectionTitle>Credenciais de Acesso</SectionTitle>
        </SectionHeader>
        <FormGrid columns={2}>
          <StyledFieldContainer>
            <FieldLabel>
              <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#667eea' }} />
              Client ID
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="client_id"
              name="client_id"
              placeholder="Client ID"
              value={values.client_id}
              onChange={handleChange}
              error={touched.client_id && Boolean(errors.client_id)}
              helperText={touched.client_id && errors.client_id}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>
          <StyledFieldContainer>
            <FieldLabel>
              <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />
              Client Secret
            </FieldLabel>
            <TextField
              fullWidth
              InputLabelProps={{ shrink: true }}
              id="client_secret"
              name="client_secret"
              placeholder="Client Secret"
              type="password"
              value={values.client_secret}
              onChange={handleChange}
              error={touched.client_secret && Boolean(errors.client_secret)}
              helperText={touched.client_secret && errors.client_secret}
              autoComplete="off"
              variant="outlined"
            />
          </StyledFieldContainer>
        </FormGrid>
      </SectionCard>

      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#16a085">
              <AccountCircle />
            </SectionIcon>
            <SectionTitle>Informações de Autenticação</SectionTitle>
          </SectionHeader>
          <FormGrid columns={1}>
            <StyledFieldContainer>
              <FieldLabel>
                <AccountCircle style={{ fontSize: '18px', marginRight: '8px', color: '#95a5a6' }} />
                User Name
              </FieldLabel>
              <TextField
                disabled
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="username"
                name="username"
                placeholder="Username"
                value={values.username}
                onChange={handleChange}
                error={touched.username && Boolean(errors.username)}
                helperText={touched.username && errors.username}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
          </FormGrid>
        </SectionCard>
      )}

      {values.id && (
        <SectionCard>
          <SectionHeader>
            <SectionIcon color="#e67e22">
              <VpnKey />
            </SectionIcon>
            <SectionTitle>Tokens e Localização</SectionTitle>
          </SectionHeader>
          <FormGrid columns={1}>
            <StyledFieldContainer>
              <FieldLabel>
                <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#9b59b6' }} />
                Refresh Token
              </FieldLabel>
              <TextField
                disabled
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="refresh_token"
                name="refresh_token"
                placeholder="Refresh Token"
                value={values.refresh_token}
                onChange={handleChange}
                error={touched.refresh_token && Boolean(errors.refresh_token)}
                helperText={touched.refresh_token && errors.refresh_token}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
            <StyledFieldContainer>
              <FieldLabel>
                <Business style={{ fontSize: '18px', marginRight: '8px', color: '#3498db' }} />
                Geo Location
              </FieldLabel>
              <TextField
                disabled
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="geo_location"
                name="geo_location"
                placeholder="Geo Location"
                value={values.geo_location}
                onChange={handleChange}
                error={touched.geo_location && Boolean(errors.geo_location)}
                helperText={touched.geo_location && errors.geo_location}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
            <StyledFieldContainer>
              <FieldLabel>
                <VpnKey style={{ fontSize: '18px', marginRight: '8px', color: '#e74c3c' }} />
                Token Expire In
              </FieldLabel>
              <TextField
                disabled
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="refresh_expires_in"
                name="refresh_expires_in"
                placeholder="Token Expire In"
                value={values.refresh_expires_in}
                onChange={handleChange}
                error={touched.refresh_expires_in && Boolean(errors.refresh_expires_in)}
                helperText={touched.refresh_expires_in && errors.refresh_expires_in}
                autoComplete="off"
                variant="outlined"
              />
            </StyledFieldContainer>
            <StyledFieldContainer>
              <FieldLabel>
                <Lock style={{ fontSize: '18px', marginRight: '8px', color: '#27ae60' }} />
                Access Token
              </FieldLabel>
              <TextField
                multiline
                disabled
                fullWidth
                InputLabelProps={{ shrink: true }}
                id="access_token"
                name="access_token"
                placeholder="Access Token"
                value={values.access_token}
                onChange={handleChange}
                error={touched.access_token && Boolean(errors.access_token)}
                helperText={touched.access_token && errors.access_token}
                autoComplete="off"
                variant="outlined"
                rows={3}
              />
            </StyledFieldContainer>
          </FormGrid>
        </SectionCard>
      )}
    </ModernFormContainer>
  );
}

export default TabConcur;

// Animações
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ModernFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-family: 'Mulish', sans-serif;
`;

const SectionCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #e8e8e8;
  animation: ${fadeIn} 0.5s ease;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
`;

const SectionIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.color ? `${props.color}15` : '#667eea15'};
  color: ${props => props.color || '#667eea'};
  margin-right: 12px;
  transition: all 0.3s ease;

  svg {
    font-size: 22px;
  }

  ${SectionCard}:hover & {
    transform: scale(1.1);
  }
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: ${props => props.columns === 2 ? 'repeat(2, 1fr)' : '1fr'};
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const StyledFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};

  .MuiOutlinedInput-root {
    border-radius: 10px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
    }

    &.Mui-focused {
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
  }

  .MuiInputLabel-outlined {
    font-family: 'Mulish', sans-serif;
    font-weight: 500;
  }

  .MuiOutlinedInput-input {
    font-family: 'Mulish', sans-serif;
  }
`;

const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;
`;

const FormLabel = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(102, 126, 234, 0.05);
    border-radius: 8px;
    padding: 12px 8px;
  }
`;

const StatusText = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${props => props.active ? '#27ae60' : '#7f8c8d'};
  font-family: 'Mulish', sans-serif;
  transition: color 0.3s ease;
`;
